import { Box, Container, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function NoDataFound() {

  const { t } = useTranslation();

  const pageType = useSelector((state) => state.filters.pageType);

  const value = pageType ? t(`noData.${pageType}`) : "";
  // const [value, setValue] = useState();

  /*  useEffect(() => {
     if (pageType) {
       if (pageType === "commissions") {
         setValue("Commission");
       } else if (pageType === "partner_requests") {
         setValue("Request");
       } else if (pageType === "bookings") {
         setValue("Bookings");
       } else if (pageType === "quotes") {
         setValue("Quotes");
       } else if (pageType === "invoices") {
         setValue("Invoices");
       } else if (pageType === "additional_services") {
         setValue("Services");
       } else if (pageType === "room_finder") {
         setValue("Accommodation");
       } else if (pageType === "add-user") {
         setValue("User");
       } else if (pageType === "add-branch") {
         setValue("Branch");
       } else if (pageType === "discount_request") {
         setValue("Discount Request");
       }
     }
   }, [pageType]); */
  return (
    <Container>
      <Box
        sx={{
          width: "100%",
          height: "400px",
          boxShadow:
            "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
          borderRadius: "6px",
          padding: "1rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#eaeaea",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <FolderOffIcon
              sx={{
                fontSize: { xs: "108px", md: "144px" },
                color: "#707070",
                filter: "drop-shadow(5px 5px 5px #909090)",
              }}
            />
          </Box>
          <Typography
            sx={{
              color: "#707070",
              fontSize: { xs: "20px", md: "28px" },
              marginTop: "1rem",
              textTransform: 'capitalize'
            }}
          >
            {/* {pageType}  */}
            {/* No {value} Found! */}
            {t("noData.noDataFound", { value })}

          </Typography>

        </Box>
      </Box>
    </Container>
  );
}
